export default "__VITE_ASSET__9734ff75__"